import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopbarPartialComponent } from './partials/topbar-partial/topbar-partial.component';
import { SidebarPartialComponent } from './partials/sidebar-partial/sidebar-partial.component';
import { ScrollToTopPartialComponent } from './partials/scroll-to-top-partial/scroll-to-top-partial.component';
import { NotificationsPartialComponent } from './partials/notifications-partial/notifications-partial.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    TopbarPartialComponent,
    SidebarPartialComponent,
    ScrollToTopPartialComponent,
    NotificationsPartialComponent,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  statusNotifications: boolean = false;

  constructor() {
    console.log('AdminLayoutComponent constructor');
  }

  ngOnInit(): void {
    console.log('AdminLayoutComponent ngOnInit');
  }

  ngOnDestroy(): void {
    console.log('AdminLayoutComponent ngOnDestroy');
  }

  notifications(value: boolean) {
    this.statusNotifications = value;
    console.log('value', value);
  }

  requestNotifications(value: boolean) {
    this.statusNotifications = value;
    console.log('requestNotifications', value);
  }
}
